import { forwardRef } from 'react';
import styled, { Box, th } from '@xstyled/styled-components';
import { ErrorMessage } from '@/UI/utils';

const StyledTextarea = styled.textareaBox`
  width: 100%;
  padding: 1rem 0.75rem 0.5rem;
  resize: none;
  outline: 0;
  border: 1.6px solid ${th.color('purple-200')};
  border-radius: 7px;

  &:focus {
    border: 1.6px solid gray;
  }

  @media (min-width: tablet) {
    width: 80%;
  }
`;

const Textarea = forwardRef((props, ref) => (
  <Box w="100%">
    <StyledTextarea
      ref={ref}
      rows="5"
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      borderColor={props.error && '#e54f4f'}
      {...props}
    />
    {props.error && <ErrorMessage>{props.error.message}</ErrorMessage>}
  </Box>
));

Textarea.displayName = 'Textarea';

export default Textarea;
